export const defaultLoyaltyLevels = [
    { id: '1', label: 'Silver', minPoints: 0, periodDays: 180, color: '#94A3B8' },
    { id: '2', label: 'Gold', minPoints: 500, periodDays: 180, color: '#FFD700' },
    { id: '3', label: 'Platinum', minPoints: 1000, periodDays: 180, color: '#9333EA' }
];

export const defaultVisitRoles = [
    { id: 'v1', label: 'Yeni', minVisits: 1, periodDays: 30, color: '#F5F5DC' },
    { id: 'v2', label: 'Potansiyel', minVisits: 2, periodDays: 30, color: '#C68642' },
    { id: 'v3', label: 'Normal', minVisits: 4, periodDays: 30, color: '#8B4513' },
    { id: 'v4', label: 'Müdavim', minVisits: 8, periodDays: 30, color: '#3E2723' },
    { id: 'v5', label: 'Riskli', minVisits: 0, periodDays: 30, color: '#FF0000' }
];

export const calculateLoyaltyLevel = (customer, tenantData) => {
    const rawLevels = tenantData?.loyaltyLevels || tenantData?.loyalty_levels;
    const levels = (rawLevels && Array.isArray(rawLevels))
        ? [...rawLevels]
        : defaultLoyaltyLevels;

    // Sort by minPoints descending to find the highest level achieved
    levels.sort((a, b) => b.minPoints - a.minPoints);

    // Business Day Logic: Day starts at 04:00 AM
    const now = new Date();
    const anchor = new Date(now);
    anchor.setHours(4, 0, 0, 0);
    if (now.getHours() < 4) {
        anchor.setDate(anchor.getDate() - 1);
    }

    for (const level of levels) {
        let pointsToCompare = 0;
        const earnings = customer.pointEarnings || [];

        if (level.periodDays && level.periodDays > 0) {
            // Rolling Window: Calculate points earned in the last X days starting from the anchor (04:00 AM)
            const cutoff = new Date(anchor.getTime() - (level.periodDays * 24 * 60 * 60 * 1000));

            pointsToCompare = earnings
                .filter(e => {
                    const d = new Date(e.t);
                    return d >= cutoff;
                })
                .reduce((sum, e) => sum + (e.p || 0), 0);
        } else {
            // Strictly use log-based points instead of the lifetime 'totalPoints' counter
            pointsToCompare = earnings.reduce((sum, e) => sum + (e.p || 0), 0);
        }

        if (pointsToCompare >= level.minPoints) {
            return level;
        }
    }

    return levels[levels.length - 1] || null;
};

export const calculateVisitFrequencyRole = (customer, tenantData) => {
    // If no roles configured, use defaults
    const rolesSource = (tenantData?.visitRoles || tenantData?.visit_roles || []).length > 0
        ? (tenantData?.visitRoles || tenantData?.visit_roles)
        : defaultVisitRoles;
    
    if (!rolesSource || rolesSource.length === 0) return null;
    
    const visits = customer.visitTimestamps || [];
    const roles = [...rolesSource].sort((a, b) => b.minVisits - a.minVisits);

    // Business Day Logic: Day starts at 04:00 AM
    const now = new Date();
    const anchor = new Date(now);
    anchor.setHours(4, 0, 0, 0);
    if (now.getHours() < 4) {
        anchor.setDate(anchor.getDate() - 1);
    }

    for (const role of roles) {
        const periodDays = role.periodDays || 30; // Default to 30 days if not set
        const minVisits = role.minVisits || 1;

        if (visits.length === 0 && customer.purchaseCount >= minVisits && !role.periodDays) {
            continue;
        }

        // Filter visits within the period starting from the anchor (04:00 AM)
        const cutoff = new Date(anchor.getTime() - (periodDays * 24 * 60 * 60 * 1000));
        const recentVisits = visits.filter(t => {
            const d = new Date(t);
            return d >= cutoff;
        }).length;

        if (recentVisits >= minVisits) return role;
    }
    return null;
};

